import { fork, call, put, all, takeEvery } from 'redux-saga/effects';
import asyncInterface from '../../asyncInterface';
import * as actionTypes from './actionTypes';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.financialAdvisorDashboard.fetchAccountData(fetchPayload);
}

export function* financialAdvisorsFetch(data) {
  yield put({ type: actionTypes.userDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.userDataSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.userDataFailedType,
      error,
    });
  }
}

export function* lazyDataFetch(data) {
  yield put({ type: actionTypes.lazyLoaderType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.lazyDataSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.lazyDataFailedType,
      error,
    });
  }
}

export function* fetchLazyDataWorker(fetchPayload) {
  yield all([fork(lazyDataFetch, fetchPayload.payload.metaData[0])]);
}

export function* fetchLazyDataWatcher() {
  yield takeEvery(actionTypes.fetchLazyLoadDataType, fetchLazyDataWorker);
}

export function* fetchFinancialAdvisorsDataWorker(fetchPayload) {
  yield all([fork(financialAdvisorsFetch, fetchPayload.payload.metaData[0])]);
}

export function* fetchFinancialAdvisorsDataWatcher() {
  yield takeEvery(
    actionTypes.userDataFetchType,
    fetchFinancialAdvisorsDataWorker
  );
}

export default function* financialAdvisorSagaWatcher() {
  yield all([fork(fetchFinancialAdvisorsDataWatcher)]);
  yield all([fork(fetchLazyDataWatcher)]);
}
